//课中活动讨论
export const Talk_LIST = 'talk_list'
export const Talk_INFO = 'talk_info'


// WEBPACK FOOTER //
// ./src/store/kzActivity/discuss/type.js